/* eslint-disable prettier/prettier */
import { FaHandshake } from 'react-icons/fa';
import { IoMdPerson, IoMdPersonAdd, IoMdStar } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import ListItem from '../ListItem';

interface ItemProps {
  fullWidth?: boolean;
}

export const Item = styled(ListItem) <ItemProps>`
  display: flex;
  padding: 28px 24px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    max-width: ${({ fullWidth }) => (fullWidth ? 'none' : '400px')};
    margin-right: 16px;
  }
`;

export const Info = styled.section`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
`;

export const CardData = styled.div`
  min-width: 0;
  flex: 1;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.styledListItem.primary};
`;

export const Description = styled.h4`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.styledListItem.secondary};
`;

interface TagProps {
  activeColor: boolean;
}

export const Tag = styled.span.attrs<any, TagProps>((): any => { })`
  display: flex;
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  padding: 6px 17px;
  line-height: 16px;
  width: fit-content;
  margin-top: 5px;
  font-size: 10px;
  background-color: ${({ activeColor, theme }) =>
    !activeColor ? theme.styledListItem.groupTag.emptyBackground : theme.styledListItem.groupTag.background};
  color: ${({ activeColor, theme }) =>
    !activeColor ? theme.styledListItem.secondary : theme.styledListItem.groupTag.color};
`;

export const EmailNotConfirmedTag = styled(Tag)`
  &:: after {
    content: '';
    height: 12px;
    width: 12px;
    margin-left: 7px;
    display: block;
    background-size: cover;
    background-position: center;
    flex-grow: 0;
    flex-shrink: 0;
    background-image: url('/images/exceeded-icon.svg');
  }
`;

export const DeleteButtonContainer = styled.div`
  text-align: center;
  margin-left:5px;
`;

export const DeleteButton = styled.button`
  background: ${ColorPalette.Transparent};
  border-color: ${ColorPalette.Transparent};
  font-size: 16px;
  cursor: pointer;
`;

export const RegisteredIcon = styled(IoMdPerson)`
  font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 10px 10px;

`;

export const InvitedIcon = styled(IoMdPersonAdd)`
 font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 10px 10px;
`;

export const ExternalIcon = styled(FaHandshake)`
   font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 10px 10px;
`;

export const AdminIcon = styled(IoMdStar)`
   font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 10px 10px;
`;
